import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const NameSettingsLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'NameSettings' */ './components/NameSettings')
);

export default (store) => {
	return {
		path: 'name-settings',
		element: <AsyncLoading component={<NameSettingsLazy />} />,
	};
};
